import { render } from "./part-panel.vue?vue&type=template&id=8927ba52"
import script from "./part-panel.vue?vue&type=script&lang=js"
export * from "./part-panel.vue?vue&type=script&lang=js"

import "./part-panel.vue?vue&type=style&index=0&id=8927ba52&lang=css"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__